import {
  GET_REPORT_SETTINGS_START,
  GET_REPORT_SETTINGS_SUCCESS,
  GET_REPORT_SETTINGS_FAILURE,
  SAVE_REPORT_SETTINGS_START,
  SAVE_REPORT_SETTINGS_SUCCESS,
  SAVE_REPORT_SETTINGS_FAILURE,
  LOGOUT_SUCCESS,
} from 'redux/actionTypes';

const initialState = {
  error: null,
  loading: false,
  id: '',
  partnerId: '',
  checkLogo: true,
  logo: '',
  checkCompanyName: true,
  companyName: '',
  checkCompanyAddress: true,
  companyAddress: '',
  checkCompanyPhone: true,
  companyPhone: '',
  checkCompanyWebSite: true,
  companyWebSite: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_SETTINGS_START: {
      return { ...state, loading: true }
    }
    case GET_REPORT_SETTINGS_SUCCESS: {
      return { ...state, loading: false, ...action.payload }
    }
    case GET_REPORT_SETTINGS_FAILURE: {
      return { ...state, loading: false, error: action.err }
    }

    case LOGOUT_SUCCESS: 
      return { ...initialState }

    case SAVE_REPORT_SETTINGS_START: {
      return state
    }
    case SAVE_REPORT_SETTINGS_SUCCESS: {
      return { ...state, ...action.payload }
    }
    case SAVE_REPORT_SETTINGS_FAILURE: {
      return { ...state, error: action.err }
    }

    default: {
      return state
    }
  }
}
